import { render, staticRenderFns } from "./mendianOrderlDetail.vue?vue&type=template&id=1123cec7&scoped=true"
import script from "./mendianOrderlDetail.vue?vue&type=script&lang=ts"
export * from "./mendianOrderlDetail.vue?vue&type=script&lang=ts"
import style0 from "./mendianOrderlDetail.vue?vue&type=style&index=0&id=1123cec7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1123cec7",
  null
  
)

export default component.exports